export function obterListaTipoOperacaoBancariaCartao() {
  return (
    [
      { label: 'Crédito', value: 'CREDITO' },
      { label: 'Débito', value: 'DEBITO' },
    ]
  );
}
